import React from 'react';
import {
  MPFCardCarousel,
  type MPFCardCarouselSlide,
} from 'volto-ministerio-publico-federal/components/UI';
import { RedeCard } from './RedeCard';
import type { RedesCard, YoutubeVideoRef } from './helpers';

interface AcompanheRedesCarouselMobileProps {
  /** Os posts pequenos (todos menos o card de vídeo do slot 5). */
  cards: RedesCard[];
  onPlay: (video: YoutubeVideoRef) => void;
  /** Presente só no editor: recebe o slot do card em `card{N}Url`. */
  onEditItem?: (slot: number) => void;
}

/**
 * A faixa "Acompanhe nossas redes" abaixo de `lg`: os posts pequenos em
 * carrossel.
 *
 * No desktop os quatro primeiros posts formam a grade 2×2; no tablet e no
 * celular viram uma esteira de ~2 cards por vez (`slidesPerView` 2,2), com o
 * terceiro cortado na borda direita, e os bullets contando o conjunto. O 5º
 * card (o vídeo) fica de fora — não é slide, é um card solto abaixo dos
 * bullets (ver `AcompanheRedesSection`), o mesmo tratamento que o card de
 * vídeo já recebe no desktop.
 *
 * Sem setas (`showArrows={false}`): no toque quem navega é o dedo, e os
 * bullets do Swiper já são focáveis pelo teclado (módulo `A11y`).
 */
export const AcompanheRedesCarouselMobile: React.FC<
  AcompanheRedesCarouselMobileProps
> = ({ cards, onPlay, onEditItem }) => {
  const slides: MPFCardCarouselSlide[] = cards.map((card) => ({
    key: String(card.slot),
    content: (
      <RedeCard card={card} onEditItem={onEditItem} onPlay={onPlay} slide />
    ),
  }));

  return (
    <MPFCardCarousel
      name="redes-mobile"
      slides={slides}
      slidesPerView={2.2}
      spaceBetween={16}
      showArrows={false}
      labels={{
        prev: 'Post anterior',
        next: 'Próximo post',
        first: 'Este é o primeiro post',
        last: 'Este é o último post',
        bullet: 'Ir para o post {{index}}',
      }}
    />
  );
};

export default AcompanheRedesCarouselMobile;
